import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Col,
    Row
} from "reactstrap";
import PolyUtil from "../../../util/PolyUtil";
import Loader from "../../../components/display/Loader";
import ListingCard from "../../../components/properties/ListingCard";

class TenantRecommendedListings extends Component {
    render() {
        const {recommended_listings} = this.props;

        return (
            <Loader spin isLoading={recommended_listings === null} style={{marginTop: '2em'}}>
                {
                    recommended_listings.length > 0 && (
                        <div>
                            <h3 className="mt-2">Recommendations</h3>
                            <hr/>
                            <Row>
                                {
                                    recommended_listings && recommended_listings.map(function (listing, i) {
                                        return (
                                            <Col key={i} xs={12} md={3}>
                                                <ListingCard listing={listing} parent="dashboard"/>
                                            </Col>
                                        );
                                    })
                                }
                            </Row>
                        </div>
                    )
                }

            </Loader>
        );
    }
}

const mapStateToProps = (state) => ({
    recommended_listings: PolyUtil.validArr(state.tenant.recommended_listings) ? state.tenant.recommended_listings.map(function (listing) {
        // recommended_listings: state.tenant.recommended_listings.slice(0, 3).map(function (listing) {
        return {
            apply_key: listing.apply_key,
            rent: PolyUtil.formatUSD(parseFloat(listing.rent)),
            display_address: PolyUtil.getPropertyStreetAddress(listing.prop),
            city: PolyUtil.getPropertyCity(listing.prop),
            state: PolyUtil.getPropertyState(listing.prop),
            identifier: listing.prop.identifier,
            prop: listing.prop
        };
    }) : []
});

export default connect(mapStateToProps)(TenantRecommendedListings);


// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/TenantRecommendedListings.js